import { CustomerInterface } from '../CustomerInterface';
import { PaymentMeanInterface } from '../Settings/PaymentMeanInterface';
import { TradeNameInterface } from '../Settings/TradeNameInterface';
import { DraftFieldsInterface } from './FieldsInterface';
import { InvoiceItemType } from './DraftItemType';
import { EmailTemplateInterface } from '../EmailTemplateInterface';

// The interface of the invoice document numbers (called via /number endpoint)
export interface InvoiceDocumentNumberType {
  prefix: string | null;
  base: number;
  next?: number;
  userDefined?: boolean;
  active?: boolean;
}

// The interface of the property invoiceNunber of the draft document
export interface DocumentNumberType {
  prefix: string | null;
  number: number | string;
}

export enum DocumentTypes {
  INVOICE = 'invoice',
  RECEIPT = 'receipt',
  ESTIMATE = 'estimate',
  CREDITNOTE = 'creditnote'
}

export type DocumentType = DocumentTypes.INVOICE |
  DocumentTypes.RECEIPT |
  DocumentTypes.ESTIMATE |
  DocumentTypes.CREDITNOTE;

export enum InvoiceTypes {
  SALES_HOUSEHOLD_SE_ROT = 10,
  SALES_HOUSEHOLD_SE_RUT = 11
}
export interface InvoicerInterface {
  tradeName: TradeNameInterface;
  vatNumber: string;
  rcs?: string;
  legalStatus?: string;
  businessId?: string;
  id: number;
  amtsgericht?: string;
  taxPrepaymentRegistered?: boolean;
  hrNr?: string;
}

export interface DraftInterface {
  id?: number;
  legacyInvoiceId?: number;
  preview?: string[];
  toBeApproved?: boolean;
  invoicer?: InvoicerInterface;
  receiver?: CustomerInterface;
  fields?: DraftFieldsInterface;
  summary?: {
    currency: string;
    grossTotal: number;
    netTotal: number;
    taxTotal: number;
    reductionTotal?: number;
    workTotal?: number;
    localReductionTotal?: number;
    localWorkTotal?: number;
    foreignReductionTotal?: number;
    foreignWorkTotal?: number;
    foreignGrossTotal?: number;
    foreignNetTotal?: number;
    foreignTaxTotal?: number;
    localGrossTotal?: number;
    localNetTotal?: number;
    localTaxTotal?: number;
    discountTotal: number;
    taxSummary: Array<{ percentage: number; amount: number; }>;
  };
  invoiceNumber?: DocumentNumberType;
  paymentMeans?: PaymentMeanInterface[];
  document: DocumentType;
  model?: string;
  styles?: {
    [key: string]: { [key: string]: string|number }
  };
  lines?: InvoiceItemType[];
  emailTemplate?: EmailTemplateInterface;
  invalidFields?: string[];
  isDirty?: boolean;
  editInvoice?: boolean;
  invoiceId?: number;
}
